import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

interface GeocodingValues {
  country?: string
  query?: string
}

export const fetchAddresses = createAsyncThunk(
  "geocoding/fetch",
  async (values: GeocodingValues) => {
    const { country, query } = values
    const q = encodeURIComponent(query || "")

    const response = await API.get(`/geocoding?country=${country}&query=${q}`)

    const { items } = response.data.geocoding
    const options = items.map(
      (option: { title: string; geocoding_id: number }) => {
        return {
          label: option.title,
          value: option.geocoding_id,
        }
      },
    )

    return {
      items,
      options,
    }
  },
)
